import { useState } from "react";
import { useT } from "../i18n/useT";
import { useSettings } from "./useSettings";

export function CalendarCard() {
  const t = useT();
  const [s, setS] = useSettings();
  const [temp, setTemp] = useState(s.icsUrl || "");
  const [saving, setSaving] = useState(false);
  const [resetting, setResetting] = useState(false);
  const [pasting, setPasting] = useState(false);

  const save = () => {
    setSaving(true);
    // NOTE: paste the RAW Moodle ICS export URL here.
    // The app fetches it through a built-in proxy worker (CORS).
    setS({ icsUrl: temp.trim(), scheduleSource: "ics" });
    window.setTimeout(() => setSaving(false), 600);
  };

  const pasteFromClipboard = async () => {
    setPasting(true);
    try {
      const text = await navigator.clipboard?.readText();
      if (text && text.trim()) {
        setTemp(text.trim());
        return;
      }
    } catch {
      // fallback below
    } finally {
      setPasting(false);
    }

    const manual = window.prompt(t("settings.calendar.pastePrompt"));
    if (manual !== null) setTemp(manual.trim());
  };

  return (
    <div className="settings-card">
      <h3>{t("settings.calendar")}</h3>

      <div className="block">
        <div className="muted small">
          💡 {t("settings.calendar.ics")}
          <br />
          <small>(Optional - use GROUP schedule as primary source)</small>
        </div>
        <div className="ics-input-row">
          <input
            className="input"
            value={temp}
            onChange={(e) => setTemp(e.target.value)}
            placeholder={t("settings.calendar.icsPlaceholder")}
            inputMode="url"
          />
          <button className={`btn ghost ${pasting ? "is-loading" : ""}`} onClick={pasteFromClipboard}>
            {t("common.paste")}
          </button>
        </div>
        <div className="muted small">{t("settings.calendar.icsHint")}</div>

        <div className="row wrap">
          <button className={`btn primary ${saving ? "is-loading" : ""}`} onClick={save}>
            {t("common.save")}
          </button>
          <button
            className={`btn ghost ${resetting ? "is-loading" : ""}`}
            onClick={() => {
              setResetting(true);
              setTemp(s.icsUrl || "");
              window.setTimeout(() => setResetting(false), 600);
            }}
          >
            {t("common.reset")}
          </button>
        </div>
      </div>

      <div className="block">
        <div className="muted small">{t("settings.calendar.refresh")}</div>
        <input
          className="input"
          type="number"
          min={1}
          max={240}
          value={s.autoRefreshMinutes || 30}
          onChange={(e) => {
            const allowed = [5, 10, 30, 60];
            const value = Number(e.target.value);
            setS({ autoRefreshMinutes: allowed.includes(value) ? value as 5 | 10 | 30 | 60 : undefined });
          }}
        />
        <div className="muted small">{t("settings.refreshMinutes")}</div>
      </div>
    </div>
  );
}
